<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <div class="text-bold">{{ CustomerInfo.Cs_Name }}
          <q-badge v-if="CustomerInfo.State_Name!=='' && CustomerInfo.State_Name!=null" align="top"
                   :label="CustomerInfo.State_Name" color="brown-5"/>
          <q-badge v-if="CustomerInfo.City_Name!=='' && CustomerInfo.City_Name!=null" align="top"
                   :label="CustomerInfo.City_Name" color="brown-5" class="q-ml-xs"/>
        </div>
        <div>
          <q-badge color="deep-orange-14"><i>شناسه(</i><b>{{ CustomerInfo.Cs_Code }}</b><i>)</i>
          </q-badge>
          <q-badge v-if="remCredit > 0" color='red-14' class="q-ml-xs"><i>بدهکاری(</i><b
              dir="ltr">{{ Math.abs(remCredit) | toCurrency }}</b><i>) ریال</i>
          </q-badge>
          <q-badge v-if="remCredit < 0" color='teal' class="q-ml-xs"><i>بستانکاری(</i><b
              dir="ltr">({{ Math.abs(remCredit) | toCurrency }})</b><i>) ریال</i>
          </q-badge>
        </div>
        <template v-slot:action>
          <q-btn icon="close" round flat v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-btn color="indigo" text-color="white" icon="payment" label="مشاهده چک ها"
             @click="payBookDialog=true"/>
      <q-card v-for="(item, index) in items" :key="index" class="q-ma-xs">
        <q-card-section class="q-pa-xs">
          <div class="text-subtitle2">
            <q-btn flat padding="none" size="md" round class="q-mt-xs"
                   color="indigo"
                   icon="print"
                   v-if="item.ArticleDesc && item.ArticleDesc.indexOf('#') > 0"
                   @click="printFactor(props.row)"/>
            <q-btn
                v-if="item.ArticleDesc && item.ArticleDesc.indexOf('#') > 0"
                round flat icon="timeline" color="indigo"
                @click="showOrderTimeLine(removeSpecialCharacter(item.ArticleDesc.split('#')[2]), item.ArticleDesc.indexOf('برگشت'))">
              <q-tooltip>
                رهگیری سفارش
              </q-tooltip>
            </q-btn>
            <q-btn
                v-if="item.ArticleDesc && item.Sale_PayReceive<item.Credit && item.ArticleDesc.indexOf('#') > 0 && $store.state.roles.some(v=>['admin','can_save_receive_pay'].includes(v))"
                flat
                round
                color="green"
                icon="attach_money">
              <q-tooltip>
                ثبت رسید پرداخت
              </q-tooltip>
              <InvoiceSettlement
                  :sale-num="parseInt(removeSpecialCharacter(item.ArticleDesc.split('#')[2]))"/>
            </q-btn>
            <q-btn flat size="md" round class="q-mt-xs"
                   color="red"
                   icon="delete"
                   @click="deleteItems(item)"
                   v-if="item.ArticleDesc && (item.ArticleDesc.indexOf('#') > 0 || item.ArticleDesc.includes('سند هزینه حمل بار')) && $store.state.roles.some(v=>['admin','can_delete_finance_document'].includes(v))">
              <q-tooltip>
                حذف سند مالی
              </q-tooltip>
            </q-btn>
            <q-space/>
            <q-badge color="red" text-color="white" align="top" :label="item.VoucherNum"/>
            {{ removeSpecialCharacter(item.ArticleDesc) }}
          </div>
          <q-chip icon="shopping_basket" square
                  :color="item.Sale_PayReceive>=item.Credit?'green':'red'"
                  text-color="white"
                  :clickable="item.ArticleDesc && !item.ArticleDesc.includes('خرید')"
                  v-if="item.ArticleDesc && item.ArticleDesc.indexOf('#') > 0"
                  @click="showFactorItems(removeSpecialCharacter(item.ArticleDesc.split('#')[2]), item.ArticleDesc.indexOf('برگشت'))">
            {{ removeSpecialCharacter(item.ArticleDesc.split('#')[2]) }}
            <q-tooltip>
              {{ item.Sale_PayReceive >= item.Credit ? 'تسویه شده' : 'تسویه نشده' }}
              <q-space v-if="item.Sale_PayReceive"/>
              <span v-if="item.Sale_PayReceive">
                          <span>مبلغ پرداختی:</span>
                          <span>  {{ item.Sale_PayReceive.toLocaleString() }}</span>
                        </span>
            </q-tooltip>
          </q-chip>
          <q-icon name="arrow_back"
                  v-if="item.ArticleDesc && item.ArticleDesc.indexOf('#') > 0 && item.BaseSale_Num_x && item.ArticleDesc && !item.ArticleDesc.includes('خرید')"/>
          <q-chip icon="shopping_basket" square
                  :clickable="item.ArticleDesc && !item.ArticleDesc.includes('خرید')"
                  :label="item.BaseSale_Num_x"
                  @click="showFactorItemsFromBaseSaleNum(item.BaseSale_Num_x, 1)"
                  v-if="item.ArticleDesc && item.ArticleDesc.indexOf('#') > 0  && item.BaseSale_Num_x && !item.ArticleDesc.includes('خرید')"/>

          <q-space/>
          <q-chip square color="teal" text-color="white"
                  v-if="item.AccName && true && item.AccName!==' ' && item.AccName!==''"
                  :label="item.AccName"/>
          <q-chip v-if="item.VoucherDate!==0" color="red" text-color="white" icon="calendar_today" square
                  :label="formatDateString(item.VoucherDate)"/>
          <q-space/>
          <q-chip v-if="item.VoucherDate!==0" color="blue-grey" text-color="white" icon="attach_money" square
                  label="بدهکار">
            <q-badge color="pink" text-color="white" :label="item.Credit.toLocaleString()"/>
          </q-chip>
          <q-chip v-if="item.VoucherDate!==0" color="blue-grey" text-color="white" icon="attach_money" square
                  label="بستانکار" class="float-right">
            <q-badge color="pink" text-color="white" :label="item.Debit.toLocaleString()"/>
          </q-chip>
        </q-card-section>
        <q-card-section class="no-padding text-center">
          <q-chip v-if="item.VoucherDate!==0" color="blue-grey" text-color="white" icon="attach_money" square
                  label="مانده">
            <q-badge color="pink" text-color="white"
                     :label="item.cum_sum >0 ?item.cum_sum.toLocaleString():`(${Math.abs(item.cum_sum).toLocaleString()})`"/>
          </q-chip>
        </q-card-section>
      </q-card>
      <q-card-actions>
        <q-btn color="indigo" icon="payment" text-color="white" label="مشاهده چک ها"
               @click="payBookDialog=true"/>
        <q-btn color="indigo"
               v-if="$store.state.roles.some(v=>['admin','can_print_customer_finance_document'].includes(v))"
               text-color="white" icon="print" label="چاپ" @click="loadReport"/>
      </q-card-actions>
    </q-card-section>
    <q-dialog :maximized="$q.screen.lt.md" v-model="payBookDialog">
      <CustomerPayBook :customer-info="CustomerInfo" :rem-credit="remCredit"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="factorDialog">
      <FactorDetails :sale-state="parseInt(saleState)" :factor-items="factorItems" :sale-kind="parseInt(saleState)"
                     :sale-num="parseInt(selectedSale_Num)"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :remain-ordered="false" :sale-num="parseInt(selectedSaleNum)" :sale-date="selectedSaleDate"/>
    </q-dialog>

    <q-dialog v-model="factorPrintDialog">
      <FactorPrintDialog title="چاپ فاکتور" :factor-info="selectedItem" :customer-code="selectedCustomerCode"/>
    </q-dialog>

  </q-card>
</template>

<script>
import CustomerPayBook from "@/components/customers/CustomerPayBook";
import {mapActions} from "vuex";
import FactorDetails from "@/components/Factor/FactorDetails";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import InvoiceSettlement from "@/components/Factor/InvoiceSettlement";
import FactorPrintDialog from "@/components/PrintDialogs/FactorPrintDialog.vue";

export default {
  name: "CustomerFinanceMobile",
  components: {FactorPrintDialog, InvoiceSettlement, OrderTimeLine, FactorDetails, CustomerPayBook},
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    CustomerInfo: {
      type: Object,
      required: true
    },
    remCredit: {
      required: true
    },
    filter: {
      type: String,
      default: () => undefined,
      required: true
    }

  },
  data() {
    return {
      factorPrintDialog: false,
      selectedItem:undefined,
      selectedCustomerCode: undefined,
      saleState: '',
      selectedSaleNum: '',
      showTimeLineDialog: false,
      selectedSaleDate: '',
      selectedSale_Num: '',
      factorItems: [],
      factorDialog: false,
      payBookDialog: false,
    }
  },
  methods: {
    ...mapActions({
      getFactorItems: 'Orders/getFactorItems',
      getFactorInfo: 'Products/getFactorInfo',
      deleteDocument: 'Orders/deleteFinanceDocument',
    }),
    async loadReport() {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با مشتریان/گزارش معین مشتری?rs:Format=PDF&Code=${this.CustomerInfo.Cs_Code}&CustomerInfo=${`${this.CustomerInfo.Cs_FirName} ${this.CustomerInfo.Cs_FamName}`}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    deleteItems(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'سند مالی حذف گردد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteDocument({
          documentNum: row.VoucherNum,
          accYear: row.VoucherDate.toString().substr(0, 4),
          Sale_Num: this.removeSpecialCharacter(row.ArticleDesc.split('#')[2]),
          SaleKind: row.ArticleDesc.indexOf('برگشت') > -1 ? -1 : 1
        }).then(() => {
          this.items = this.items.filter(item => item.VoucherNum !== row.VoucherNum)
        })
      })
    },
    showOrderTimeLine(saleNum, saleKind) {
      const payload = {Sale_Num: parseInt(saleNum.trim()), Sale_Kind: saleKind > -1 ? -1 : 1}
      this.getFactorInfo(payload).then((res) => {
        if (res.length > 0) {
          if (res[0].Order_Num) {
            this.selectedSaleNum = res[0].Order_Num
            this.selectedSaleDate = res[0].Sale_Date
            this.showTimeLineDialog = true
          }
        }
      })
    },
    async printFactor(rowInfo) {
      this.selectedItem = rowInfo
      this.selectedCustomerCode = rowInfo.Cs_Code
      this.factorPrintDialog = true
    },
    showFactorItems(sale_num, saleKind) {
      this.saleState = saleKind > 0 ? -1 : 1;
      this.getFactorItems({
        sale_num: sale_num,
        sale_kind: this.saleState
      }).then((res) => {
        this.factorItems = res
        this.selectedSale_Num = parseInt(sale_num)
        this.factorDialog = true
      })
    },
    showFactorItemsFromBaseSaleNum(sale_num, saleKind) {
      this.saleState = 1
      this.getFactorItems({
        sale_num: sale_num,
        sale_kind: saleKind
      }).then((res) => {
        this.factorItems = res
        this.selectedSale_Num = parseInt(sale_num)
        this.factorDialog = true
      })
    },
    removeSpecialCharacter(str) {
      if (str) {
        return str.replace(/[#<>]/gi, ' ');
      } else {
        return ''
      }
    },
    formatDateString(str) {
      let moment = require('jalali-moment');
      let MomentDate = moment(str, 'jYYYYjMMjDD');
      return MomentDate.locale('fa').format('yyyy/MM/DD')
    },
  }
}
</script>

<style scoped>

</style>